import type { RuntimeBindingArgPolicy } from './types';

export function normalizeBindingArgForPolicy(
    arg: string | null | undefined,
    argPolicy: RuntimeBindingArgPolicy,
    bindingId: string,
    argOptions?: ReadonlyArray<readonly [string, string]>
): string | null {
    const normalizedArg = arg?.trim() || null;

    if (argPolicy === 'forbidden') {
        if (normalizedArg !== null) {
            throw new Error(`Runtime binding "${bindingId}" does not support "arg".`);
        }

        return null;
    }

    if (argPolicy === 'required' && normalizedArg === null) {
        throw new Error(`Runtime binding "${bindingId}" requires "arg".`);
    }

    if (
        normalizedArg !== null &&
        argOptions &&
        !argOptions.some(([value]) => value === normalizedArg)
    ) {
        throw new Error(`Runtime binding "${bindingId}" does not support arg "${normalizedArg}".`);
    }

    return normalizedArg;
}
